import React from 'react';
import { Col, Row } from 'react-bootstrap';

import BounceRate from './bounce-rate/BounceRate';
import TrafficSource from './traffic-source/TrafficSource';


const Firewall = () => {
  return (
    <>
      

      <Row className="g-3">
        <Col lg={5} xxl={6}>
          <BounceRate />
        </Col>
        <Col lg={7} xxl={6}>
          <TrafficSource />
        </Col>
      </Row>
    </>
  );
};

Firewall.propTypes = {};

export default Firewall;
